<template>
    <div id="edit">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i>Premade Categories</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">
                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="premadeCategory.name" rules="required" placeholder='Name'/>
                    </div>
                </div>
                <div class="column is-6">
                    <div class="field">
                        <multiselect v-model="premadeCategory.schools" label="name" name="test" track-by="name" :options="schools" :multiple="true"  placeholder="Choose schools"></multiselect>
                    </div>
                </div>

            </div>
            <div class="columns is-multiline">
                <div class="column is-2">
                    <span class="heading">Background color </span>
                        <swatches :show-border="true" :row-length="5" v-model="premadeCategory.color" popover-to="left" show-fallback :colors="material" ></swatches>
                    <!--<swatches :row-length="5" :show-border="false" v-model="color" show-fallback >-->

                    </swatches>
                </div>
                <div class="column is-1">
                    <span class="heading">Text color </span> <swatches v-model="premadeCategory.text_color" :show-border="true" show-fallback colors="text-basic"></swatches>
                </div>
            </div>
            <div class="columns is-multiline">
                <div class="column is-2">
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>
                </div>
                <div class="column is-2 is-offset-8 is-pulled-right">
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import _ from 'lodash'
import Swatches from 'vue-swatches'

export default {
    name: 'premade-categories-edit',
    components: {Swatches},
    props: {},
    data() {
    return {
        loading: false,
        schools: [],
        premadeCategory: {schools : [], color :'#3D4351', text_color: '#00d1b2'},
    }
    },
    created(){
        this.loadSchools();
    },
    methods: {
        getPremadeCategory(id){
            this.premadeCategoryRepo.get(id).then(response => {
                this.premadeCategory = response.data.data;
                this.color = this.premadeCategory.color;
                this.text_color = this.premadeCategory.text_color;
            });
        },
        loadSchools(){
          this.loading = true;
          this.schoolRepo.all().then(response => {
              this.schools = response.data.data;
              this.loading = false;
              this.getPremadeCategory(this.$route.params.id);

          }).catch((response) =>{
              this.loading = false;
              return Promise.reject(response);
          });
        },
        save(){
            this.$validator.validateAll().then((result) => {
            if (result) {
                    let self = this;
                    this.loading = true;

                    this.premadeCategoryRepo.update(this.premadeCategory.id, this.premadeCategory).then(function (response) {

                        self.loading = false;
                        self.$toast.success(response.data.message);
                        self.$router.push('/dashboard/premade-categories');
                    }).catch(function(response){
                        self.loading = false;
                        return Promise.reject(response);
                    });
                }
            });

        },
    },
    watch: {

    }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/premade-categories/Edit.vue